var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "pl-3 pr-3 mb-3" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-header" }, [
        _c("div", { staticClass: " text-light" }, [
          _c(
            "div",
            { staticClass: "d-flex justify-content-between align-items-top " },
            [
              _c("div", [
                _c("div", {
                  staticClass: "d-inline-block",
                  domProps: { innerHTML: _vm._s(_vm.page_title) }
                }),
                _vm._v(" "),
                _vm.expires !== ""
                  ? _c("div", { staticClass: "small" }, [
                      _vm._v("Refreshes: " + _vm._s(_vm.expires))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-inline-block dashboard-module-small--value ml-2"
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.currency) +
                        _vm._s(_vm.money(_vm.sale_total)) +
                        "\n                        "
                    )
                  ]
                )
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c(
          "div",
          {
            staticClass: "table-max-height watch-transition",
            class: {
              "table-max-height--extended": _vm.selected_event.id !== null
            }
          },
          [
            _c("div", { staticClass: "table-responsive" }, [
              _c("div", { staticClass: "d-table table table-striped" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tbody" },
                  [
                    _vm._l(_vm.products, function(event) {
                      return _vm.products
                        ? [
                            _c(
                              "div",
                              {
                                key: event.id,
                                staticClass: "d-table-row cursor-pointer",
                                class: {
                                  "bg-primary": event.show_detail == true
                                },
                                on: {
                                  click: function($event) {
                                    _vm.updateSelectedEvent(event)
                                  }
                                }
                              },
                              [
                                _c("div", { staticClass: "td " }, [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.lang("title", event.event_data.lang)
                                      ) +
                                      "\n                                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "td text-right" }, [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.makeDate(event.start_date.date)
                                      ) +
                                      "\n                                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "td text-right" }, [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(_vm.currency) +
                                      _vm._s(_vm.money(event.sold_total)) +
                                      "\n                                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "td text-right" }, [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(event.sold_count) +
                                      "\n                                    "
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "d-table-row",
                                attrs: { "data-event-tickets-module": "" }
                              },
                              [
                                _vm.selected_event.id == event.id
                                  ? [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(_vm.log(event)) +
                                          "\n                                        "
                                      ),
                                      _c("event-tickets-module", {
                                        attrs: {
                                          colspan: "3",
                                          no_header: true,
                                          no_card: true,
                                          is_table: true,
                                          "data-type": "event-tickets-module",
                                          currency: _vm.currency,
                                          event_data: event,
                                          event_tickets: event.tickets,
                                          sale_route_uri: _vm.sale_route_uri
                                        }
                                      })
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        : _vm._e()
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "tfoot" }, [
                  _c("div", { staticClass: "d-table-row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "d-table-cell text-right font-weight-bold "
                      },
                      [
                        _vm._v(
                          "\n                                    Total\n                                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-table-cell text-right" }, [
                      _vm._v(
                        "\n                                    " +
                          _vm._s(_vm.money(_vm.sale_total)) +
                          "\n                                "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-table-cell text-right" })
                  ])
                ])
              ])
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "thead" }, [
      _c("div", { staticClass: "d-table-row" }, [
        _c("div", { staticClass: "th" }, [_vm._v("Event")]),
        _vm._v(" "),
        _c("div", { staticClass: "th" }, [_vm._v("Event Date")]),
        _vm._v(" "),
        _c("div", { staticClass: "th text-right" }, [_vm._v("Amount")]),
        _vm._v(" "),
        _c("div", { staticClass: "th text-right" }, [_vm._v("Sold")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09a9639c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09a9639c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/modules/SalesTotalByEvent.vue
// module id = 695
// module chunks = 0